import { VueNodeViewRenderer } from "@tiptap/vue-2";
import { Node, mergeAttributes } from "@tiptap/core";
import FooterView from "../nodeViews/FooterView";
const PageFooter = Node.create({
    name: "pageFooter",
    content: "block+",
    group: "headerFooter",
    isolating: true,
    selectable: false,
    defining: true,
    allowGapCursor: false,

    renderHTML({ HTMLAttributes }) {
        return [
            "div",
            mergeAttributes(HTMLAttributes, { class: "page-footer" }),
            0,
        ];
    },

    parseHTML() {
        return [
            {
                tag: "div",
                getAttrs: (node) => node.className.split(" ").includes("page-footer") ? {} : false,
            },
        ];
    },
    addNodeView() {
        return VueNodeViewRenderer(FooterView);
    },
});

export default PageFooter;
